import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@app/shared/components/base/base.component';
import {
    DistributionDocument
} from '@app/shared/models/distribution-doc-models';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { DrFileMeta, DrFileMetaCategoryList, DrFileMetaList } from '@app/shared/models/dr-file';

@Component({
    templateUrl: './select-templates-dialog.component.html',
    styleUrls: ['./select-templates-dialog.component.scss']
})
export class SelectTemplatesDialogComponent extends BaseComponent implements OnInit {

    public selectedCategory: DrFileMetaList;
    public selectedTemplates: DrFileMeta[];

    constructor(public dialogRef: MatDialogRef<SelectTemplatesDialogComponent >,
                @Inject(MAT_DIALOG_DATA) public data: {
                    title: string,
                    templates: DrFileMetaCategoryList,
                    selectedDocuments: DistributionDocument[]
    }) {
        super();
        this._idPrefix = 'select_templates_dialog.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.data.title = this.data.title || marker('select-templates-dialog.title.add_templates');
        this.selectedTemplates = [];

        if (this.data.templates && this.data.templates.items.length) {
            this.data.templates.items.forEach(fileMetaList => fileMetaList.actionListDisplayName = `template_categories.${fileMetaList.document_type}`);
            this.selectTemplateMetaList(this.data.templates.items[0]);
        }
    }

    public showLeft(template: DrFileMeta): boolean {
        const idx = this.selectedCategory.entries.indexOf(template);
        const maxIdx = this.selectedCategory.entries.length - 1;
        return idx <= Math.floor(maxIdx / 2);
    }

    public selectTemplateMetaList(selected: DrFileMetaList): void {
        this.selectedCategory = selected;
    }

    public templateIsSelected(template: DrFileMeta): boolean {
        return !!this.selectedTemplates.find(templ => templ === template);
    }

    public jobAlreadyContainsDocument(template: DrFileMeta): boolean {
        if (this.data.selectedDocuments) {
            return !!this.data.selectedDocuments.find(doc => {
                return template.is_placeholder ?
                    (doc.is_placeholder && template.document_type === doc.document_type) :
                    (doc.document_key === template.document_key);
            });
        }

        return false;
    }


    public toggleTemplateSelection(template: DrFileMeta, value: boolean): void {
        value ? this.selectedTemplates.push(template) :
                this.selectedTemplates = this.selectedTemplates.filter(templ => templ !== template);
    }

    public accept(): void {
        this.dialogRef.close(this.selectedTemplates);
    }

    public close(): void {
        this.dialogRef.close(false);
    }
}
